exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip__anchor__2bvKm{display:inline-block;vertical-align:top;overflow:hidden}", ""]);

// exports
exports.locals = {
	"anchor": "tooltip__anchor__2bvKm"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/components/tooltip/tooltip.css
// module id = 753
// module chunks = 0